// ========================================
// VARIANT SAVINGS - ABO PRICE UPDATE
// Updated savings when switching to subscription
// ========================================

(function () {
  "use strict";

  const updateVariantSavings = () => {
    const isSubscription =
      document.querySelector(
        'input[name="purchase_type"][value="autodeliver"]:checked'
      ) ||
      document.querySelector(
        ".rc_widget__option--active:not(.rc-option__onetime)"
      );

    if (!isSubscription) {
      const variantItems = document.querySelectorAll(
        "[data-js-variant-selector-item]"
      );
      variantItems.forEach((item) => {
        const savingsElement = item.querySelector(
          ".VariantSelector__OptionSavings"
        );
        if (!savingsElement) return;

        const originalSavings = item.getAttribute("data-js-savings");
        if (
          originalSavings &&
          savingsElement.classList.contains(
            "VariantSelector__OptionSavings--subscription"
          )
        ) {
          const formattedOriginal = originalSavings.startsWith("-")
            ? originalSavings
            : `-${originalSavings}`;
          savingsElement.textContent = formattedOriginal;
          savingsElement.classList.remove(
            "VariantSelector__OptionSavings--subscription"
          );
        }
      });

      return;
    }

    let subscriptionDiscount = 0;
    const discountElement = document.querySelector(
      ".rc_widget__option__discount, [data-discount]"
    );
    if (discountElement) {
      const match = discountElement.textContent.match(/(\d+)%/);
      if (match) {
        subscriptionDiscount = parseInt(match[1]);
      }
    }

    if (subscriptionDiscount === 0) return;

    const variantItems = document.querySelectorAll(
      "[data-js-variant-selector-item]"
    );

    variantItems.forEach((item) => {
      const savingsElement = item.querySelector(
        ".VariantSelector__OptionSavings"
      );
      if (!savingsElement) return;

      const optionValue = item.getAttribute("data-js-option-value");
      const variant = getVariantByOption(optionValue);
      if (!variant) return;

      const subscriptionPrice = Math.round(
        variant.price * (1 - subscriptionDiscount / 100)
      );

      let savings = 0;
      if (
        variant.compare_at_price &&
        variant.compare_at_price > subscriptionPrice
      ) {
        savings = variant.compare_at_price - subscriptionPrice;
      } else {
        savings = variant.price - subscriptionPrice;
      }

      if (savings <= 0) return;

      const formattedSavings = formatMoney(savings);
      savingsElement.textContent = `-${formattedSavings}`;
      savingsElement.classList.add(
        "VariantSelector__OptionSavings--subscription"
      );
    });
  };

  const getVariantByOption = (optionValue) => {
    const productData = document.querySelector(
      'script[type="application/json"][data-product-json]'
    );
    if (!productData) return null;

    try {
      const data = JSON.parse(productData.textContent);
      const product = data.product;

      return (
        product.variants.find(
          (v) =>
            v.title === optionValue ||
            v.title.includes(optionValue) ||
            v.option1 === optionValue ||
            v.option2 === optionValue ||
            v.option3 === optionValue
        ) || null
      );
    } catch (e) {
      return null;
    }
  };

  const formatMoney = (cents) => {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      return Shopify.formatMoney(
        cents,
        window.theme.moneyFormat || "{{amount}}"
      );
    }
    return "€" + (cents / 100).toFixed(2).replace(".", ",");
  };

  const watchRechargeChanges = () => {
    document.addEventListener("click", (e) => {
      const rechargeOption = e.target.closest(".rc_widget__option");
      if (rechargeOption) {
        setTimeout(updateVariantSavings, 100);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      watchRechargeChanges();
      updateVariantSavings();
    });
  } else {
    watchRechargeChanges();
    setTimeout(updateVariantSavings, 1000);
  }
})();